(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-gallery-state"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-gallery-state')) {
    customElements.define('tt-gallery-state', class extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('product-images');
        if (!gallery) return;
        const sync = () => {
          const active = gallery.getAttribute('data-active-media');
          gallery.querySelectorAll('[data-thumb-link]').forEach(link => {
            if (link.getAttribute('data-media-id') === active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(gallery, { attributes: true, attributeFilter: ['data-active-media'] });
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-preorder-choice"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const template = document.getElementById('tt-preorder-choice-template');
      const page = document.querySelector('.tt-product-page');
      if (!template || !page || page.dataset.ttOrderReady) return;
      page.dataset.ttOrderReady = 'true';
      let scheduled = false;
      const visibility = (element) => element && getComputedStyle(element).display !== 'none';
      const setMode = (block, choice, mode) => {
        block.dataset.ttOrderMode = mode;
        choice.querySelectorAll('[data-tt-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ttChoice === mode)));
        choice.querySelector('.tt-order-choice__notice').hidden = mode !== 'notify';
      };
      const observe = () => observer.observe(page, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-variant-id', 'style', 'class'] });
      const enhance = () => {
        scheduled = false;
        observer.disconnect();
        page.querySelectorAll('.product__block--buttons').forEach(block => {
          const form = block.querySelector('product-form');
          if (!form) return;
          let choice = block.querySelector('.tt-order-choice');
          if (!choice) {
            choice = template.content.firstElementChild.cloneNode(true);
            form.before(choice);
            choice.addEventListener('click', event => {
              const button = event.target.closest('[data-tt-choice]');
              if (button) setMode(block, choice, button.dataset.ttChoice);
            });
          }
          const widget = form.querySelector('.restock-rocket-payment-widget');
          const variant = form.querySelector('input[name="id"]')?.value;
          const preorderButton = form.querySelector('.restock-rocket-preorder-button');
          const active = widget && widget.dataset.variantId === variant && visibility(widget) && preorderButton;
          if (!active) {
            choice.hidden = true;
            delete block.dataset.ttOrderMode;
            return;
          }
          choice.hidden = false;
          if (choice.dataset.variant !== variant || !block.dataset.ttOrderMode) {
            choice.dataset.variant = variant;
            setMode(block, choice, 'preorder');
          }
          const notify = block.querySelector('.restock-rocket-button-product');
          choice.querySelector('[data-tt-choice="notify"]').hidden = !notify;
          if (notify && notify.textContent !== choice.dataset.notifyLabel) notify.textContent = choice.dataset.notifyLabel;
          widget.querySelectorAll('.restock-rocket-payment-description-text').forEach(text => {
            const description = text.parentElement;
            const terms = text.textContent.trim();
            const sentences = terms.match(/[^.!?]+[.!?]+(?:\s|$)/g);
            if (!sentences || sentences.length < 3) return;
            const existing = text.closest('.tt-order-details');
            if (existing) {
              const short = existing.previousElementSibling;
              const value = sentences.slice(0, 3).join('').trim();
              if (short?.classList.contains('tt-order-payment-summary') && short.textContent !== value) short.textContent = value;
              return;
            }
            const short = document.createElement('span');
            short.className = 'tt-order-payment-summary';
            short.textContent = sentences.slice(0, 3).join('').trim();
            const details = document.createElement('details');
            details.className = 'tt-order-details';
            const summary = document.createElement('summary');
            summary.textContent = choice.dataset.paymentDetails;
            details.append(summary, text);
            description.append(short, details);
          });
          const delivery = form.querySelector('.restock-rocket-preorder-description');
          if (delivery && !delivery.querySelector('.tt-order-details')) {
            const content = delivery.querySelector('.preorder-description-details');
            if (content) {
              const details = document.createElement('details');
              details.className = 'tt-order-details';
              const summary = document.createElement('summary');
              const nativeText = content.textContent.trim();
              const firstSentence = nativeText.match(/^[^.!?]+[.!?]/)?.[0];
              summary.textContent = firstSentence || choice.dataset.deliveryDetails;
              details.append(summary, content);
              delivery.append(details);
            }
          }
        });
        observe();
      };
      const schedule = () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(enhance); }
      };
      const observer = new MutationObserver(schedule);
      page.addEventListener('change', event => {
        if (event.target.matches('input[name="id"], variant-selects input')) schedule();
      });
      const updateNotify = () => {
        const copy = page.querySelector('.tt-order-choice');
        if (!copy) return;
        const consent = document.querySelector('#form-Consent-Container > div');
        if (consent && consent.textContent !== copy.dataset.marketingLabel) consent.textContent = copy.dataset.marketingLabel;
        const description = document.getElementById('form-Description');
        const activeChoice = page.querySelector('[data-tt-order-mode] .tt-order-choice');
        if (description && activeChoice && description.textContent !== copy.dataset.notifyDescription) description.textContent = copy.dataset.notifyDescription;
      };
      const popupObserver = new MutationObserver(mutations => {
        if (mutations.some(mutation => Array.from(mutation.addedNodes).some(node => node.nodeType === 1 && (node.id === 'formContainer' || node.querySelector?.('#formContainer, #form-Consent-Container'))))) updateNotify();
      });
      popupObserver.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', event => {
        if (event.target.closest('.restock-rocket-button-container')) requestAnimationFrame(updateNotify);
      });
      enhance();
      updateNotify();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-product-ux"] && !Shopify.designMode) return;
  try {
    (() => {
    const openReviews = (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter') return;
      if (!(event.target instanceof Element)) return;
      const summary = event.target.closest('.tt-product-page .junip-product-summary-star-ratings-container');
      const reviews = document.querySelector('main .junip-product-review-rendered');
      if (!summary || !reviews) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const heading = reviews.querySelector('h2');
      if (heading) {
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      }
      reviews.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    document.addEventListener('click', openReviews, true);
    document.addEventListener('keydown', openReviews, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-purchase-bar')) {
    customElements.define('tt-purchase-bar', class extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('product-info');
        if (!this.productSection) return;
        this.hasSelection = this.dataset.noOptions === 'true' || this.dataset.explicitVariant === 'true';
        this.frame = null;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.updateVisibility(); });
        };
        this.onChange = (event) => {
          const sizeControl = this.productSection.querySelector('.selector-wrapper--size');
          if (event.target.closest('variant-selects .selector-wrapper--size') || !sizeControl && event.target.closest('variant-selects')) this.hasSelection = true;
          this.scheduleSync();
        };
        this.onSelect = (event) => {
          if (event.target.closest('variant-selects .selector-wrapper--size label, variant-selects .selector-wrapper--size input')) {
            this.hasSelection = true;
            this.scheduleSync();
          }
        };
        this.onClick = (event) => {
          if (!event.target.closest('[data-tt-bar-action]')) return;
          this.sync();
          const source = this.sourceButton;
          if (this.querySelector('[data-tt-bar-action]')?.disabled) return;
          if (this.hasSelection && source && !source.disabled && source.getAttribute('aria-disabled') !== 'true') {
            source.click();
            if (window.a11y) window.a11y.lastElement = this.querySelector('[data-tt-bar-action]');
          } else {
            this.returnToOptions();
          }
        };
        this.onError = () => {
          if (this.wasVisible) this.returnToOptions();
        };
        this.addEventListener('click', this.onClick);
        this.productSection.addEventListener('change', this.onChange);
        this.productSection.addEventListener('click', this.onSelect);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('theme:product:add-error', this.onError);
        this.observer = new MutationObserver((records) => {
          if (records.some(record => !this.contains(record.target) || record.target === this)) this.scheduleSync();
        });
        this.observer.observe(this.productSection, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value'], characterData: true });
        this.lockObserver = new MutationObserver(() => this.updateVisibility());
        this.lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-scroll-locked'] });
        this.sync();
      }
      scheduleSync() {
        if (this.syncFrame) return;
        this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.sync(); });
      }
      sync() {
        this.sourceButton = this.productSection.querySelector('product-form [data-add-to-cart]');
        const action = this.querySelector('[data-tt-bar-action]');
        if (!action) return;
        const source = this.sourceButton;
        const sourceText = source?.querySelector('[data-add-to-cart-text]')?.cloneNode(true);
        sourceText?.querySelectorAll('[data-product-price]').forEach(element => element.remove());
        const text = sourceText?.textContent.trim();
        const ready = this.hasSelection && source && !source.disabled && source.getAttribute('aria-disabled') !== 'true';
        const label = ready && text ? text : this.dataset.chooseLabel;
        if (action.textContent !== label) action.textContent = label;
        const loading = source?.classList.contains('is-loading') || source?.getAttribute('aria-busy') === 'true';
        action.disabled = Boolean(loading);
        const selection = this.querySelector('[data-tt-bar-selection]');
        const variantInput = this.productSection.querySelector('form[data-product-form] input[name="id"]');
        const validVariant = Boolean(variantInput?.value);
        if (selection) selection.hidden = !this.hasSelection || !validVariant || this.dataset.noOptions === 'true';
        const price = this.querySelector('[data-tt-bar-price]');
        if (price) price.hidden = !validVariant;
        this.updateVisibility();
      }
      updateVisibility() {
        const source = this.sourceButton;
        const rect = source?.getBoundingClientRect();
        const shown = Boolean(source && rect?.width && rect?.height && rect.bottom < 0 && !document.documentElement.hasAttribute('data-scroll-locked'));
        if (shown !== this.wasVisible) {
          this.wasVisible = shown;
          this.classList.toggle('is-visible', shown);
          this.inert = !shown;
          this.setAttribute('aria-hidden', String(!shown));
          document.documentElement.toggleAttribute('data-tt-purchase-bar-visible', shown);
        }
        if (shown) document.documentElement.style.setProperty('--cart-bar-height', `${this.offsetHeight}px`);
      }
      returnToOptions() {
        const options = this.productSection.querySelector('.selector-wrapper--size') || this.productSection.querySelector('variant-selects') || this.sourceButton;
        if (!options) return;
        const focusTarget = options.querySelector('input:checked') || options.querySelector('select, input:not([type="hidden"])') || options.querySelector('button') || options;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        options.scrollIntoView({ behavior, block: 'center' });
        focusTarget.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.productSection?.removeEventListener('change', this.onChange);
        this.productSection?.removeEventListener('click', this.onSelect);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('theme:product:add-error', this.onError);
        this.observer?.disconnect();
        this.lockObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.syncFrame);
        document.documentElement.removeAttribute('data-tt-purchase-bar-visible');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
